<div class="session-condition-dialog-component dialog-component">
  <div class="dialog-title">
    <div class="title-row">
      <div class="icon-container">
        @if (sessionCondition.conditionConfig.svgIcon) {
          <mat-icon class="filter-icon tb-icon" [svgIcon]="sessionCondition.conditionConfig.svgIcon"></mat-icon>
        }
        @if (sessionCondition.conditionConfig && sessionCondition.conditionConfig.icon) {
          <mat-icon class="filter-icon">
            {{ sessionCondition.conditionConfig.icon }}
          </mat-icon>
        }
      </div>
      <div class="text-container">
        <span class="filter-label">{{ "audience.settings.condition" | translate }}:&nbsp;</span>
        @if (sessionCondition) {
          <span>{{ sessionCondition.conditionConfig?.titleKey | translate }}</span>
        }
      </div>
      @if (sessionCondition.conditionConfig.isNew) {
        <span class="new-addon">NEW</span>
      }
    </div>
  </div>
  @if (loadingOptions) {
    <div class="dialog-content">
      <mat-spinner [diameter]="48" [mode]="'indeterminate'"></mat-spinner>
    </div>
  }

  @if (!loadingOptions) {
    <div class="dialog-content">
      <div class="text-and-operator">
        @if (!operatorFirst) {
          <div class="filter-description-text">{{ leadInKey | translate }}:</div>
        }
        @if (comparisonOptions.length > 1) {
          <div class="operator-box" [matMenuTriggerFor]="comparisonsDropdown" data-test="session-condition-comparison">
            <span class="operator-text">{{ conditionComparisonLabelKey | translate }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <mat-menu #comparisonsDropdown="matMenu" class="operators-dropdown-menu">
            @for (option of comparisonOptions; track option.value) {
              <button mat-menu-item (click)="comparisonUpdated(option.value)">{{ option.labelKey | translate }}</button>
            }
          </mat-menu>
        }
        @if (operatorFirst) {
          <div class="filter-description-text">{{ leadInKey | translate }}</div>
        }
        @if (showOperator) {
          <div class="operator-box" [matMenuTriggerFor]="operatorsDropdown">
            <span class="operator-text">{{ "audience.operators." + conditionOperator | translate }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <mat-menu #operatorsDropdown="matMenu" class="operators-dropdown-menu">
            <div fxLayout="column" fxLayout.xs="column">
              @for (operator of sessionCondition.conditionConfig?.supportedOperators; track operator) {
                <div>
                  <button mat-menu-item (click)="filterOperatorUpdated(operator)">
                    <span>{{ "audience.operators." + operator | translate }}</span>
                  </button>
                </div>
              }
            </div>
          </mat-menu>
        }
      </div>
      @if (filterInputType === FilterInputTypes.BooleanDropdown) {
        <mat-form-field class="boolean-dropdown-value" appearance="outline" [class.invalid]="conditionValueError">
          <mat-select [(value)]="filterValueString" required>
            <mat-option [value]="'true'">{{ "generic.yes" | translate }}</mat-option>
            <mat-option [value]="'false'">{{ "generic.no" | translate }}</mat-option>
          </mat-select>
          @if (conditionValueError) {
            <mat-hint class="invalid">
              {{ "generic.required" | translate }}
            </mat-hint>
          }
        </mat-form-field>
      }
      @if (filterInputType === FilterInputTypes.TextField) {
        <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="conditionValueError">
          <input matInput type="text" [(ngModel)]="filterValueString" required placeholder="{{ placeholderKey | translate }}" />
          @if (conditionValueError) {
            <mat-hint class="invalid">
              {{ "generic.required" | translate }}
            </mat-hint>
          }
        </mat-form-field>
        @if (sessionCondition.type === SessionConditionTypes.CookieEquals) {
          <div class="cookie-equals">
            <span>{{ "audience.session-condition-groups.conditionTypeInfoText.CookieEquals" | translate }}</span>
          </div>
        }
      }
      @if (filterInputType === FilterInputTypes.Number) {
        <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="conditionValueError || valueBelowMinimumError">
          <input matInput type="number" [(ngModel)]="filterValueNumber" required placeholder="{{ placeholderKey | translate }}" />
          @if (conditionValueError) {
            <mat-hint class="invalid">
              {{ "generic.required" | translate }}
            </mat-hint>
          } @else if (valueBelowMinimumError) {
            <mat-hint class="invalid" data-test="session-condition-minimum-error">
              {{ "audience.session-condition-groups.returning-visitor-less-than-min" | translate: { min: minimumValue } }}
            </mat-hint>
          }
        </mat-form-field>
      }
      @if (filterInputType === FilterInputTypes.SingleChoiceDropdown && !isCampaignCondition) {
        <mat-form-field class="single-choice-dropdown-value" appearance="outline" [class.invalid]="conditionValueError">
          <mat-select [(value)]="filterValueString" required placeholder="{{ 'generic.choose' | translate }}">
            @for (valueOption of choosableValueOptions; track valueOption) {
              <mat-option [value]="valueOption.key">
                <span>{{ valueOption.value | translate }}</span>
              </mat-option>
            }
          </mat-select>
          @if (conditionValueError) {
            <mat-hint class="invalid">
              {{ "generic.required" | translate }}
            </mat-hint>
          }
        </mat-form-field>
      }
      @if (filterInputType === FilterInputTypes.SingleChoiceDropdown && isCampaignCondition) {
        <app-widget-selector-menu
          [items]="allWidgets"
          [idSource]="'campaign'"
          [value]="selectedCampaignId"
          (valueChange)="onCampaignSelected($event)"
          [placeholder]="'generic.choose' | translate"></app-widget-selector-menu>
        @if (conditionValueError) {
          <mat-hint class="invalid">
            {{ "generic.required" | translate }}
          </mat-hint>
        }
      }
      @if (filterInputType === FilterInputTypes.MultiChoiceDropdown) {
        <mat-form-field class="multiple-choice-dropdown-value" appearance="outline" [class.invalid]="conditionValueError">
          <mat-select [(value)]="filterValueArray" multiple required>
            @for (valueOption of choosableValueOptions; track valueOption) {
              <mat-option [value]="valueOption.key">
                <span [innerHTML]="valueOption.value"></span>
              </mat-option>
            }
          </mat-select>
          @if (conditionValueError) {
            <mat-hint class="invalid">
              {{ "generic.required" | translate }}
            </mat-hint>
          }
        </mat-form-field>
      }
      @if (filterInputType === FilterInputTypes.JavascriptTextArea) {
        <app-code-editor
          [(value)]="filterValueString"
          [lineNumbers]="true"
          [wordWrap]="true"
          [minHeight]="64"
          [maxHeight]="208"
          [invalid]="conditionValueError"></app-code-editor>
        @if (conditionValueError) {
          <mat-hint class="invalid">
            {{ "generic.required" | translate }}
          </mat-hint>
        }
        <div class="javascript-instructions" [innerHTML]="'campaign.settings.conditions.js-expression-hint' | translate"></div>
      }
      @if (CampaignSessionConditionTypes.indexOf(sessionCondition?.type) !== -1) {
        <div class="campaign-count-row" style="margin-top: 30px">
          <div class="operator-box" [matMenuTriggerFor]="campaignEventOperatorsDropdown">
            <span class="operator-text">{{ "audience.session-condition-groups.campaignEventCountOperators." + campaignEventOperator | translate }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <mat-menu #campaignEventOperatorsDropdown="matMenu" class="operators-dropdown-menu">
            <div fxLayout="column" fxLayout.xs="column">
              @for (operator of SessionConditionCampaignEventOperators; track operator) {
                <div>
                  <button mat-menu-item (click)="campaignEventOperatorUpdated(operator)">
                    <span>{{ "audience.session-condition-groups.campaignEventCountOperators." + operator | translate }}</span>
                  </button>
                </div>
              }
            </div>
          </mat-menu>
          <mat-form-field class="time-window-field small-input-field" [class.invalid]="!!campaignEventCountError">
            <input matInput type="number" [formControl]="campaignEventCountFC" [min]="0" [max]="10" required />
          </mat-form-field>
          <div class="label">&nbsp;&nbsp;{{ "generic.times" | translate | lowercase }}</div>
        </div>
        @if (campaignEventCountError) {
          <div class="timeframe-validation-row">{{ campaignEventCountError | translate }}</div>
        }
      }
      @if (sessionCondition.conditionConfig?.descriptionKey2) {
        <div [innerHTML]="sessionCondition.conditionConfig.descriptionKey2 | translate"></div>
      }
    </div>
  }

  @if (filterInputType === FilterInputTypes.JavascriptTextArea) {
    <app-no-csp-support-info class="no-csp-info" script="true" />
  }

  <div class="actions-row">
    <button mat-stroked-button class="secondary-button" (click)="closeDialog()">{{ "generic.cancel" | translate }}</button>
    <button mat-stroked-button class="primary-button" (click)="saveCondition()">{{ "generic.save" | translate }}</button>
  </div>
</div>
